import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { defaultLang } from './config-lang'
import roLocales from './langs/ro'
import ruLocales from './langs/ru'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ro: { hiv: roLocales },
      ru: { hiv: ruLocales }
    },
    ns: ['hiv'],
    defaultNS: 'hiv',
    fallbackLng: defaultLang.value,
    debug: false,
    keySeparator: '.',
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: '.'
    }
  })

export default i18n
